<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" item-key="ID" show-select v-model="selected"
            fixed-header height="calc(100vh - 300px)">
            <template v-slot:item="{ item, isSelected, select }">
                <tr :active="isSelected" @click="select(!isSelected)">
                <td>
                  <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                </td>
                <td>{{ item.BillCode }}</td>
                <td>{{ item.CustomerName }}</td>
                <td class="text-right">{{ item.NumberOfCode | currency }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-right">{{ item.Deposit | currency('¥', 2) }}</td>
                <td class="text-right">{{ item.FeeShipVND | currency }}</td>
                <td class="text-right">{{ item.DiscountAmount | currency }}</td>
                <td class="text-right">{{ item.AmountVND | currency }}</td>
                <td class="text-right">{{ item.LineAmount | currency }}</td>
                <td class="text-right">{{ item.PaidAmount | currency }}</td>
                <td class="text-right" :class="{'red--text': item.LineAmount - item.PaidAmount > 0}">{{ item.LineAmount - item.PaidAmount | currency }}</td>
                <td>{{ item.ExportDate | display_date }}</td>
                <td>
                  <v-chip small dark :color="get_status_color(item.Status, bill_status_list)">
                    {{ item.Status | display_value(bill_status_list) }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <table-action-buttons :actions="getItemActions(item)"></table-action-buttons>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { currency } from "@/commons/currency";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      selected: [],
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      bill_status_list: configs.BILL_STATUS_LIST,
      bill_status: configs.BILL_STATUS,
      viewName: "bill_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      headers: [
        {
          text: this.$t('table_headers.bill_code'),
          value: "BillCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.$t('table_headers.customer_name'),
          value: "CustomerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.$t('table_headers.number_of_code'),
          value: "NumberOfCode",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_pack'),
          value: "NumberOfPack",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_weight'),
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_volume'),
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_deposit'),
          value: "Deposit",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.fee_ship_vnd'),
          value: "FeeShipVND",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.discount_amount'),
          value: "DiscountAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.amount_vnd'),
          value: "AmountVND",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.line_amount'),
          value: "LineAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.paid_amount'),
          value: "PaidAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.remaining_amount'),
          value: "PaidAmount",
          sortable: false,
          filterable: false,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.export_date'),
          value: "ExportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: this.$t('table_headers.status'),
          value: "Status",
          filterable: true,
          values: configs.BILL_STATUS_LIST,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: this.$t('table_headers.action'),
          width: "100px",
          align: "center",
          sortable: false,
          filterable: false
        },
      ]
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    roleAdmin() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleAdmin});
    }
  },
  computed: {
    ...mapState({
      items: state => state.bill.all.data,
      total_rows: state => state.bill.all.total,
      currentItem: state => state.bill.selected,
      loading: state => state.bill.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    roleCustomer() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
    },
    roleAdmin() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
    }
  },
  methods: {
    getItemActions(item) {
      return [
        { label: this.isBillLocked(item.Status) || !this.roleAdmin ? this.$t('actions.view') : this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
        { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !this.roleAdmin, disabled: this.isBillLocked(item.Status), onClick: () => this.deleteItem(item.ID) }
      ];
    },
    printLabel(packageCode, weight, volume) {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write("<html><head><title></title>");
      mywindow.document.write(
        "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
      );
      mywindow.document.write(
        ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
      );
      mywindow.document.write(
        ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
      );
      mywindow.document.write(
        "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
      );
      mywindow.document.write("<div class='layout wrap'>");
      mywindow.document.write(
        `<div class='flex lg12'><p class='title'>${packageCode}</p></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(weight)} kg</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(volume)}</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
          new Date()
        ).format("DD-MM-YYYY")}</p></div></div>`
      );
      mywindow.document.write(`<hr class='v-divider theme--light'>`);
      mywindow.document.write(
        `<div class='flex lg12'><p class='note-text'>csimex.vn transportation & logistics</p></div>`
      );
      mywindow.document.write("</div>");
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      return true;
    },
    isBillLocked(status) {
      return Number(status || this.bill_status.chua_xuat) !== this.bill_status.chua_xuat;
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bill/getList", param);
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    newItem: function () {
      this.$store.commit("bill/setDetail", { 'ID': 0 });
      let route = this.$router.resolve({
          name: this.roleCustomer ? "CustomerBillDetail" : "BillDetail",
          params: { Pid: 'new', title: `Phiếu xuất mới` }
      });
      window.open(route.href, '_blank');
    },
    openItem: function (id) {
      let route = this.$router.resolve({
          name: this.roleCustomer ? "CustomerBillDetail" : "BillDetail",
          params: { Pid: id, title: `Chi tiết phiếu xuất (#${id})` }
      });
      window.open(route.href, '_blank');
    },
    saveItem(item) {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bill/setDetail", {
        'data': item,
        'id': item.ID,
        'param': param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    exportData() {
      let ids = _.map(this.selected, "ID");
      var param = {
          pagination: this.pagination,
          filter: [...this.filterConditions],
          quickFilter: this.quickFilterConditions
      };
      if (ids.length > 0) {
        param.filter.push({
          column: "ID",
          value: ids,
          condition: "in",
        });
      }
      this.$store.dispatch("bill/exportList", param);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleAdmin});
    this.$root.$on("REQUEST_CREATE_DATA", this.newItem);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bill/removeDetail", id);
    });
    this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.newItem);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("REQUEST_EXPORT_ACTION");
  }
};
</script>
